import React from "react";
import styled from "styled-components";
import { projects } from "../../data/constants";
import ProjectCard from "../cards/ProjectCard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;
  padding: 0px 16px;
  position: relative;
  z-index: 1;
  align-items: center;
  background-color: transparent;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: ${({ theme }) => theme.white};
  margin-bottom: 2rem;
  font-family: 'JetBrains Mono', monospace;
  letter-spacing: -0.02em;
  align-self: flex-start;

  &::before {
    content: "~/ ";
    color: ${({ theme }) => theme.primary};
  }

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 30px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: 100%;
  margin-top: 20px;
`;

const Projects = () => {
  return (
    <Container id="Projects">
      <Wrapper>
        <SectionTitle>Projects.md</SectionTitle>
        <Desc>
          I have worked on a wide range of projects, from full stack web apps to cross-platform android apps.
        </Desc>

        <ProjectsContainer>
          {projects.map((project, index) => (
            <ProjectCard 
              key={project.id} 
              project={project} 
              index={index} 
              id={`project-${project.id}`}
            />
          ))}
        </ProjectsContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
